module.exports = __webpack_public_path__ + "img/vertical_6_7_3.45a55086.png";